import { createFailAction } from '../../redux-util/async-helpers';
import { createReducer } from '../../redux-util/general-helpers';

import { getUid } from '../../../utils/uid';
import {
  ALL_ASSIGNMENTS,
  DELETE_ASSIGNMENT,
} from 'app/api/redux-feeny/assignments/actions';

const actions = [DELETE_ASSIGNMENT, ALL_ASSIGNMENTS];

const handlers = {};
actions.forEach(a => {
  const key = createFailAction(a).type;
  handlers[key] = (state, action) => {
    return [
      ...state,
      {
        type: a,
        id: getUid(),
      },
    ];
  };
});

export default createReducer([], handlers);
